import { Button } from "@telegram-apps/telegram-ui";
import React from "react";

export default function Popup({
  children,
  revert,
}: {
  children: React.ReactNode;
  revert?: () => void;
}) {
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
          padding: 50,
        }}
      >
        <div>
          {children}
          {revert && (
            <Button
              size="s"
              mode="plain"
              onClick={() => {
                revert();
              }}
            >
              取り消す
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
